import React from "react";
import { motion } from "framer-motion";
import { WHATSAPP_URL } from "@/lib/scroll";

export const WhatsAppFab = () => (
  <motion.a
    data-testid="whatsapp-fab"
    href={WHATSAPP_URL}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Scrivici su WhatsApp"
    initial={{ scale: 0, opacity: 0 }}
    animate={{ scale: 1, opacity: 1 }}
    transition={{ delay: 1.2, type: "spring", stiffness: 260, damping: 18 }}
    whileHover={{ scale: 1.08 }}
    whileTap={{ scale: 0.94 }}
    className="fixed bottom-5 right-5 z-[60] flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] shadow-[0_12px_30px_rgba(37,211,102,0.45)] md:h-16 md:w-16"
  >
    <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#25D366] opacity-30" />
    <svg viewBox="0 0 32 32" className="relative h-7 w-7 md:h-8 md:w-8" fill="#fff" aria-hidden="true">
      <path d="M16.003 3C9.383 3 4 8.383 4 15.003c0 2.117.553 4.184 1.604 6.01L4 29l8.184-1.57a11.94 11.94 0 0 0 3.819.625h.001C22.62 28.055 28 22.672 28 16.052 28 9.43 22.62 3 16.003 3zm0 21.86h-.001a9.9 9.9 0 0 1-3.53-.652l-.253-.1-4.855.932.98-4.73-.164-.243a9.86 9.86 0 0 1-1.51-5.264c0-5.463 4.446-9.906 9.916-9.906 2.648 0 5.135 1.032 7.006 2.904a9.83 9.83 0 0 1 2.902 7.005c0 5.463-4.446 9.907-9.914 9.907zm5.44-7.42c-.298-.15-1.764-.87-2.037-.97-.273-.1-.472-.15-.67.15-.198.297-.767.968-.94 1.166-.173.199-.347.223-.644.075-.298-.15-1.26-.464-2.4-1.48-.887-.79-1.486-1.767-1.66-2.065-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.15-.174.198-.298.298-.497.099-.199.05-.372-.025-.521-.075-.15-.67-1.614-.918-2.21-.242-.58-.487-.502-.67-.512l-.57-.01c-.198 0-.52.075-.792.372s-1.04 1.017-1.04 2.48 1.065 2.876 1.213 3.075c.149.198 2.095 3.2 5.076 4.487.71.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.764-.721 2.012-1.417.248-.696.248-1.293.173-1.417-.074-.124-.272-.198-.57-.347z"/>
    </svg>
  </motion.a>
);
